export default __webpack_public_path__ + "static/media/Levitate D5.3 Medium term impacts of CCAM in urban transport.15b22eb7.pdf";